import { STORAGE_LANGUAGE_NAME } from "constants/variables";
import { useChatWootStore } from "stores/chatwoot";
// import { useGTM } from "./useGTM";
// import { useIntercomController } from './useIntercomController';
import styles from "../theme/_vars.module.sass";

export const useSupport = () => {
  // const { init } = useIntercomController();
  // const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const currentLanguage = localStorage.getItem(STORAGE_LANGUAGE_NAME);
  // const GTM = useGTM();
  const isInit = useChatWootStore((state) => state.isInit);
  const setIsInit = useChatWootStore((state) => state.setIsInit);
  const setIsLoading = useChatWootStore((state) => state.setIsLoading);

  return () => {
    // eslint-disable-next-line no-console
    console.log("CLICK SUPPORT", isInit);
    // if (VITE_APP_PROJECT_NAME === 'banger') {
    //     GTM.openIntercom();
    //     init();
    // } else {
    if (isInit && window.$chatwoot) {
      // eslint-disable-next-line no-console
      console.log("window.$chatwoot", window.$chatwoot);
      if (currentLanguage) {
        window.$chatwoot.setLocale(currentLanguage.toLowerCase());
      }
      const chatwootWidgetHolder = document.querySelector(
        ".woot-widget-holder",
      ) as HTMLElement;
      if (chatwootWidgetHolder) {
        chatwootWidgetHolder.style.setProperty(
          "z-index",
          styles.chatwootIndex,
          "important",
        );
      }
      window.$chatwoot.toggle("open");
    } else {
      setIsLoading(true);
      setIsInit(true);
    }

    // }
  };
};
